import { graphql } from '../../graphql';

export const getAllItemsCount = graphql(`
  query AllItemsCount {
    itemsPublishedTodayCount
  }
`);
